export default [
  {
    path: 'phase-1',
    name: 'onBoard.neofintech.phase1',
    children: [
      {
        path: '1',
        name: 'onBoard.neofintech.phase1.1',
        meta: {
          prev: null,
          next: 'onBoard.neofintech.phase1.2',
          name: 'País de tu empresa',
          hasSidebox: true,

          extra: {
            colors: {
              primary: '#fb6996',
              dark: '#de4282',
              helpModal: '#8cc63f'
            },
            step: {
              number: 1,
              text: 'Ampliar, elegir y cliquear',
              icon: 'hand_click'
            },
            help: {
              text: 'Elige el país de tu empresa'
            },
            sideHelp: {
              text: 'Elige el país de tu empresa'
            },
            wheel: {
              text: 'País de tu empresa'
            },
            quote: {
              text: 'Q1T',
              author: 'Q1A'
            }
          },
          hasBottomBar: true
        },
        component: () =>
          import(
            /* webpackChunkName: "onboard" */
            '@/views/on-board/neofintech/phase-1/1.vue'
          )
      },
      {
        path: '2',
        name: 'onBoard.neofintech.phase1.2',
        meta: {
          prev: 'onBoard.neofintech.phase1.1',
          next: 'onBoard.neofintech.phase1.3',
          name: 'Ubicación de oportunidades de negocio',
          hasBottomBar: true,
          showNext: true,
          hasSidebox: true,
          extra: {
            colors: {
              primary: '#fb6996',
              dark: '#de4282',
              helpModal: '#8cc63f'
            },
            step: {
              number: 2,
              text: 'Ampliar, elegir y cliquear',
              icon: 'hand_click'
            },
            wheel: {
              text: 'Ubicación oportunidades'
            },
            sideHelp: {
              text: 'Elige el país dónde está tu oportunidad de negocio'
            },
            help: {
              text: 'Elige el país dónde está tu oportunidad de negocio'
            },
            quote: {
              text: 'Q2T',
              author: 'Q2A'
            }
          }
        },
        component: () =>
          import(
            /* webpackChunkName: "onboard" */
            '@/views/on-board/neofintech/phase-1/2.vue'
          )
      },
      {
        path: '3',
        name: 'onBoard.neofintech.phase1.3',
        meta: {
          prev: 'onBoard.neofintech.phase1.2',
          next: 'onBoard.neofintech.phase1.4',
          name: 'Tipo de empresa',
          hasBottomBar: true,
          hasSidebox: true,
          hasMariposa: true,
          extra: {
            colors: {
              primary: '#fb6996',
              dark: '#de4282',
              helpModal: '#ffcc00'

            },
            step: {
              number: 3,
              text: 'Deslizar, elegir y cliquear',
              icon: 'hand_click'
            },
            sideHelp: {
              text: 'Seleccionar tu tipo de empresa'
            },
            help: {
              text: 'Seleccionar tu tipo de empresa'
            },
            wheel: {
              text: 'Tipo de empresa'
            },
            quote: {
              text: 'Q3T',
              author: 'Q3A'
            }
          }
        },
        component: () =>
          import(
            /* webpackChunkName: "onboard" */
            '@/views/on-board/neofintech/phase-1/3.vue'
          )
      },
      {
        path: '4',
        name: 'onBoard.neofintech.phase1.4',
        meta: {
          prev: 'onBoard.neofintech.phase1.3',
          next: 'onBoard.neofintech.phase1.5',
          name: 'Sector Económico',
          hasBottomBar: true,
          hasSidebox: true,
          extra: {
            colors: {
              primary: '#fb6996',
              dark: '#de4282',
              helpModal: '#5baa35'
            },
            step: {
              number: 4,
              text: 'Deslizar, elegir y cliquear',
              icon: 'hand_click'
            },
            wheel: {
              text: 'Sector Económico'
            },
            sideHelp: {
              text: 'Seleccionar el sector económico de tu empresa'
            },
            help: {
              text: 'Seleccionar el sector económico de tu empresa'
            },
            quote: {
              text: 'Q4T',
              author: 'Q4A'
            }
          }
        },
        component: () =>
          import(
            /* webpackChunkName: "onboard" */
            '@/views/on-board/neofintech/phase-1/4.vue'
          )
      },
      {
        path: '5',
        name: 'onBoard.neofintech.phase1.5',
        meta: {
          prev: 'onBoard.neofintech.phase1.4',
          next: 'onBoard.neofintech.phase1.6',
          name: 'Actividad en sector',
          hasBottomBar: true,
          hasSidebox: true,

          extra: {
            colors: {
              primary: '#fb6996',
              dark: '#de4282',
              helpModal: '#e87c36'
            },
            step: {
              number: 5,
              text: 'Deslizar, elegir y cliquear',
              icon: 'hand_click'
            },
            wheel: {
              text: 'Actividad en sector'
            },
            sideHelp: {
              text: 'Seleccionar la actividad de tu empresa'
            },
            help: {
              text: 'Seleccionar la actividad de tu empresa'
            },
            quote: {
              text: 'Q5T',
              author: 'Q5A'
            }
          }
        },
        component: () =>
          import(
            /* webpackChunkName: "onboard" */
            '@/views/on-board/neofintech/phase-1/5.vue'
          )
      },
      {
        path: '6',
        name: 'onBoard.neofintech.phase1.6',
        meta: {
          prev: 'onBoard.neofintech.phase1.5',
          next: 'onBoard.neofintech.phase1.7',
          name: 'Programa de capital alternativo',
          hasBottomBar: true,
          hasSidebox: true,
          extra: {
            colors: {
              primary: '#fb6996',
              dark: '#de4282',
              helpModal: '#0070c0'
            },
            step: {
              number: 6,
              text: 'Deslizar, elegir y cliquear',
              icon: 'hand_click'
            },
            wheel: {
              text: 'Programa de capital alternativo'
            },
            sideHelp: {
              text: 'Seleccionar el tipo de programa de capital alternativo que estás buscando'
            },
            help: {
              text: 'Seleccionar el tipo de programa de capital alternativo que estás buscando'
            },
            quote: {
              text: 'Q6T',
              author: 'Q6A'
            }
          }
        },
        component: () =>
          import(
            /* webpackChunkName: "onboard" */
            '@/views/on-board/neofintech/phase-1/6.vue'
          )
      },
      {
        path: '7A',
        name: 'onBoard.neofintech.phase1.7A',
        meta: {
          prev: 'onBoard.neofintech.phase1.6',
          next: 'onBoard.neofintech.phase1.8',
          name: 'Tipo de inversión',
          hasBottomBar: true,
          hasSidebox: true,
          extra: {
            colors: {
              primary: '#fb6996',
              dark: '#de4282',
              helpModal: '#019644'
            },
            step: {
              number: 7,
              text: 'Deslizar, elegir y cliquear',
              icon: 'hand_click'
            },
            wheel: {
              text: 'Tipo de inversión'
            },
            sideHelp: {
              text: 'Seleccionar el tipo de inversión que estás buscando'
            },
            help: {
              text: 'Seleccionar el tipo de inversión que estás buscando'
            },
            quote: {
              text: 'Q7T',
              author: 'Q7A'
            }
          }
        },
        component: () =>
          import(
            /* webpackChunkName: "onboard" */
            '@/views/on-board/neofintech/phase-1/7A.vue'
          )
      },
      {
        path: '7B',
        name: 'onBoard.neofintech.phase1.7B',
        meta: {
          prev: 'onBoard.neofintech.phase1.6',
          next: 'onBoard.neofintech.phase1.8',
          name: 'Beneficiario de la garantía',
          hasBottomBar: true,
          hasSidebox: true,
          extra: {
            colors: {
              primary: '#019644',
              dark: '#019644',
              helpModal: '#019644'
            },
            step: {
              number: 7,
              text: 'Deslizar, elegir y cliquear',
              icon: 'hand_click'
            },
            wheel: {
              text: 'Beneficiario de la garantía'
            },
            sideHelp: {
              text:  'Seleccionar el beneficiario del programa de garantía'
            },
            help: {
              text: 'Seleccionar el beneficiario del programa de garantía'
            },
            quote: {
              text: 'Q8T',
              author: 'Q8A'
            }
          }
        },
        component: () =>
          import(
            /* webpackChunkName: "onboard" */
            '@/views/on-board/neofintech/phase-1/7B.vue'
          )
      },
      {
        path: '8B',
        name: 'onBoard.neofintech.phase1.8B',
        meta: {
          prev: 'onBoard.neofintech.phase1.6',
          next: null,
          name: 'Detalles',
          hasBottomBar: true,
          hasSidebox: false,
          extra: {
            colors: {
              primary: '#fb6996',
              dark: '#de4282',
              helpModal: '#0070c0'
            },
            step: {
              number: 8,
              text: 'Detalles',
              icon: 'hand_click'
            },
            wheel: {
              text: 'Detalles'
            },
            quote: {
              text: 'Q9T',
              author: 'Q9A'
            }
          }
        },
        component: () =>
          import(
            /* webpackChunkName: "onboard" */
            '@/views/on-board/neofintech/phase-1/8B.vue'
          )
      },
      {
        path: '8',
        name: 'onBoard.neofintech.phase1.8',
        meta: {
          prev: 'onBoard.neofintech.phase1.6',
          next: null,
          name: 'Resumen',
          hasBottomBar: true,
          hasSidebox: false,
          extra: {
            colors: {
              primary: '#fb6996',
              dark: '#de4282',
              helpModal: '#0070c0'
            },
            step: {
              number: 8,
              text: 'Resumen',
              icon: 'hand_click'
            },
            wheel: {
              text: 'Resumen'
            },
            quote: {
              text: 'Q9T',
              author: 'Q9A'
            }
          }
        },
        component: () =>
          import(
            /* webpackChunkName: "onboard" */
            '@/views/on-board/neofintech/phase-1/8.vue'
          )
      },
      {
        path: 'status/:id',
        props: true,
        name: 'onBoard.neofintech.phase1.status',
        meta: {
          prev: null,
          next: null,
          name: 'Estado',
          hasBottomBar: false,
          extra: {
            colors: {
              primary: '#fb6996',
              dark: '#de4282'
            },
            step: {
              number: 9,
              text: 'Estado',
              icon: 'hand_click'
            },
            wheel: {
              text: 'Estado'
            },
            quote: {
              text: 'Q10T',
              author: 'Q10A'
            }
          }
        },
        component: () =>
          import(
            /* webpackChunkName: "onboard" */
            '@/views/on-board/neofintech/phase-1/status.vue'
          )
      },
      {
        path: 'detail/:id',
        props: true,
        name: 'onBoard.neofintech.phase1.detail',
        meta: {
          prev: null,
          next: null,
          name: 'Detallar',
          hasBottomBar: false,
          extra: {
            colors: {
              primary: '#fb6996',
              dark: '#de4282'
            },
            step: {
              number: 10,
              text: 'Detallar',
              icon: 'hand_click'
            },
            wheel: {
              text: 'Detallar'
            },
            quote: {
              text: 'Q11T',
              author: 'Q11A'
            }
          }
        },
        component: () =>
          import(
            /* webpackChunkName: "onboard" */
            '@/views/on-board/neofintech/phase-1/detail.vue'
          )
      }
    ],
    component: () =>
      import(
        /* webpackChunkName: "onboard" */
        '@/views/on-board/neofintech/phase-1/Phase1.vue'
      )
  }
]
